import { render } from "./ProductSelectionTrademarksSelectionItemBadges.vue?vue&type=template&id=857111d2&scoped=true&ts=true"
import script from "./ProductSelectionTrademarksSelectionItemBadges.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionTrademarksSelectionItemBadges.vue?vue&type=script&lang=ts"

import "./ProductSelectionTrademarksSelectionItemBadges.vue?vue&type=style&index=0&id=857111d2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-857111d2"]])

export default __exports__